(function () {
  console.log("[Free Gift] Script loaded");

  const GIFT_VARIANT_ID = 47399367049475;
  const GIFT_THRESHOLD = 25;
  let giftJustAdded = false;
  let modalCreated = false;

  // Variant IDs to exclude from triggering free gift
  const EXCLUDED_VARIANT_IDS = [
    47618897608963, // Panel 2
    47618898886915, // Panel 3
    47618904981763, // Panel 4 Left
    47618891448579  // Panel 4 Right
  ];

  function isCartPage() {
    return window.location.pathname === '/cart';
  }

  function createModal() {
    if (modalCreated) return;
    modalCreated = true;

    const modalHTML = `
      <div class="free-gift-modal-overlay" id="free-gift-modal-overlay">
        <div class="free-gift-modal">
          <div class="free-gift-modal__confetti-bg"></div>
          <button class="free-gift-modal__close" id="free-gift-modal-close">&times;</button>
          <div class="free-gift-modal__icon">🎁</div>
          <h2 class="free-gift-modal__title">Free Gift Added!</h2>
          <img class="free-gift-modal__image" id="free-gift-modal-image" src="" alt="Free Gift">
          <p class="free-gift-modal__product-name" id="free-gift-modal-product-name"></p>
          <p class="free-gift-modal__message">was added to your cart</p>
          <a href="/cart" class="free-gift-modal__button">View Cart</a>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    document.getElementById('free-gift-modal-close').addEventListener('click', closeModal);
    document.getElementById('free-gift-modal-overlay').addEventListener('click', function (e) {
      if (e.target === this) closeModal();
    });
  }

  function showModal(productTitle, variantTitle, imageUrl) {
    console.log("[Free Gift] Showing modal");
    createModal();

    const overlay = document.getElementById('free-gift-modal-overlay');
    const imageEl = document.getElementById('free-gift-modal-image');
    const nameEl = document.getElementById('free-gift-modal-product-name');

    const displayName = variantTitle && variantTitle !== 'Default Title'
      ? productTitle + ' - ' + variantTitle
      : productTitle;

    nameEl.textContent = displayName;

    if (imageUrl) {
      imageEl.src = imageUrl;
      imageEl.style.display = 'block';
    } else {
      imageEl.style.display = 'none';
    }

    overlay.classList.add('is-visible');
    setTimeout(closeModal, 5000);
  }

  function closeModal() {
    const overlay = document.getElementById('free-gift-modal-overlay');
    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  }

  function checkAndAddGift() {
    console.log("[Free Gift] Checking cart...");
    if (giftJustAdded) return;

    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const subtotal = cart.items_subtotal_price / 100;
        const hasGift = cart.items.some(item => item.variant_id === GIFT_VARIANT_ID);

        const excludedItemInCart = cart.items.some(item =>
          EXCLUDED_VARIANT_IDS.includes(item.variant_id) && item.quantity === 1
        );

        console.log("[Free Gift] Subtotal:", subtotal, "Has gift:", hasGift, "Excluded variant present:", excludedItemInCart);

        if (excludedItemInCart) {
          console.log("[Free Gift] Skipping gift logic due to excluded variant.");
          return;
        }

        // Add gift if eligible
        if (subtotal >= GIFT_THRESHOLD && !hasGift) {
          giftJustAdded = true;
          console.log("[Free Gift] Adding gift...");

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
          })
            .then(function (res) { return res.json(); })
            .then(function (data) {
              console.log("[Free Gift] Added:", data);

              if (isCartPage()) {
                location.reload();
                return;
              }

              showModal(
                data.product_title,
                data.variant_title,
                data.image ? data.image.replace(/(\.[^\.]+)$/, '_300x$1') : null
              );

              fetch("/cart.js")
                .then(function (res) { return res.json(); })
                .then(function (cartData) {
                  window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cartData }));
                });

              setTimeout(function () { giftJustAdded = false; }, 3000);
            })
            .catch(function (err) {
              console.error("[Free Gift] Error:", err);
              giftJustAdded = false;
            });
        }

        // Remove gift if not eligible
        if (subtotal < GIFT_THRESHOLD && hasGift) {
          console.log("[Free Gift] Removing gift...");
          const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);

          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 })
          }).then(function () {
            if (isCartPage()) {
              location.reload();
              return;
            }

            fetch("/cart.js")
              .then(function (res) { return res.json(); })
              .then(function (cartData) {
                window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cartData }));
              });
          });
        }
      });
  }

  // Initial check on load
  checkAndAddGift();

  // Debounce repeated cart updates
  let checkGiftTimeout;
  window.addEventListener('cartcount:update', function () {
    console.log("[Free Gift] cartcount:update received");
    clearTimeout(checkGiftTimeout);
    checkGiftTimeout = setTimeout(checkAndAddGift, 500);
  });
})();
